import { render, staticRenderFns } from "./ot-switch-wrapper.vue?vue&type=template&id=c3290e7a&scoped=true&"
import script from "./ot-switch-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-switch-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-switch-wrapper.vue?vue&type=style&index=0&id=c3290e7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3290e7a",
  null
  
)

export default component.exports